import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import { createId, clsx } from '../../../utils/';

import icons from './icons.json';

type IconProps = {
  classes?: string[] | string;
  icon: keyof typeof icons;
  viewBox?: string;
  onclick?: () => void;
  tabindex?: boolean;
};

const Icon: LitheFC<IconProps> = ({
  id = createId(),
  testId = 'icon',
  classes,
  icon,
  viewBox,
  onclick,
  tabindex,
}): LitheElement<'svg'> => [
  'svg',
  {
    id,
    'data-testid': testId,
    viewBox: viewBox ?? '0 -960 960 960',
    class: ['w-8 h-8 fill-text', ...clsx(classes)],
    onclick,
    ...(tabindex ? { tabindex: '0' } : {}),
  },
  ['path', { d: icons[icon as keyof typeof icons] ?? icons.image }],
];

export default Icon;
